import { useQuery } from '@apollo/client';
import Loading from '../../../common/loading/components/Loading';
import PurchasedCheckIn from '../components/check-in/v1/purchased-checkin/PurchasedCheckIn';
import ErrorPage from '../../status-pages/components/ErrorPage';
import { CHECKIN_STATUS_QUERY } from './queries';

const PurchasedCheckInGraphqlContainer = (props) => {
  const { loading, data, error } = useQuery(CHECKIN_STATUS_QUERY, {
    fetchPolicy: 'no-cache',
  });

  if (error) {
    return <ErrorPage />;
  }

  if (loading) {
    return <Loading />;
  }

  return <PurchasedCheckIn {...props} checkInStatus={data.checkInStatus} />;
};

export default PurchasedCheckInGraphqlContainer;
